export default __webpack_public_path__ + "assets/images/ROI9-e6caf3ce5701ce1760334018b82decdb.png";